import React from 'react';
import styles from './ItemContainer.module.scss';
import { nameTableColumn } from '../../../../../pages/ReportRSOPage/constants/nameTableRso';
import useSelectedValuesColumn from '../../../../../pages/ReportRSOPage/hooks/useSelectedValuesColumn';
import { Checkbox, Form } from 'antd';
import CustomItem from '../../../../../pages/ReportRSOPage/components/common/CustomItem/CustomItem';
import BoxColumnTariff from '../BoxColumnTariff/BoxColumnTariff';

import { useDispatch, useSelector } from 'react-redux';
import { setHighlightedColumns } from '../../../store/actions/rsoImportActions';

import usePersoneContainerEffect from '../../../hooks/usePersoneContainerEffect';
import useClickCreateRso from '../../../hooks/useClickCreateRso';

const ItemContainer = ({ form }) => {
  const { getFieldValue, getFieldDecorator, setFieldsValue } = form;

  const dispatch = useDispatch();

  const { highlightedColumns, valueForm } = useSelector(
    (state) => state.rsoImportStore
  );

  const columnsAddressStartValue = getFieldValue(
    nameTableColumn.columnsAddressStart
  );

  const { getOptionsColumnForSelect, onClearValuesAddressEnd } =
    useSelectedValuesColumn(form);

  const onClickBtn = useClickCreateRso(form);

  const onChangeColumnItem = (fieldName, val) => {
    if (fieldName === nameTableColumn.columnsAddressEnd && val !== undefined) {
      onClearValuesAddressEnd(val);
    }

    dispatch(setHighlightedColumns(fieldName, val));
  };

  const highlightColor = (fieldName) =>
    highlightedColumns.find((c) => c.name === fieldName)?.color || '#ffffff';

  usePersoneContainerEffect(form);

  return (
    <div className={styles.root}>
      <CustomItem
        form={form}
        highlightColor={highlightColor}
        options={getOptionsColumnForSelect}
        fieldName={nameTableColumn.columnSerialNumber}
        label="Столбец с номерами ИПУ"
        requiredMessage="Пожалуйста, выберите столбец с номерами ИПУ"
        onChange={onChangeColumnItem}
        isClear={true}
      />

      <Form.Item
        label="Присутствуют двухтарифные счетчики"
        style={{ display: 'flex', margin: 0 }}
      >
        {getFieldDecorator('hasTwoTariffCounters', {
          valuePropName: 'checked',
          initialValue: valueForm?.[nameTableColumn.columnTariff]
            ? true
            : false,
        })(
          <Checkbox
            onChange={(e) => {
              if (!e.target.checked) {
                onChangeColumnItem(nameTableColumn.columnTariff, null);
                setFieldsValue({
                  [nameTableColumn.columnTariff]: undefined,
                  [nameTableColumn.MeterTriffs_One]: undefined,
                  [nameTableColumn.MeterTriffs_Two]: undefined,
                });
              }
            }}
            className={styles.customCheckboxRso}
          />
        )}
      </Form.Item>

      <BoxColumnTariff
        form={form}
        highlightColor={highlightColor}
        getOptionsColumnForSelect={getOptionsColumnForSelect}
        onChangeColumnItem={onChangeColumnItem}
      />

      <CustomItem
        form={form}
        highlightColor={highlightColor}
        highlightColorName={nameTableColumn.columnsAddress}
        options={getOptionsColumnForSelect}
        fieldName={nameTableColumn.columnsAddressStart}
        label="Столбец начала адреса"
        requiredMessage="Пожалуйста, выберите столбец начала адреса"
        onChange={onChangeColumnItem}
        isClear={true}
      />

      <CustomItem
        form={form}
        highlightColor={highlightColor}
        highlightColorName={nameTableColumn.columnsAddress}
        options={getOptionsColumnForSelect}
        fieldName={nameTableColumn.columnsAddressEnd}
        label="Столбец конечного элемента адреса"
        onChange={onChangeColumnItem}
        isClear={true}
        disabled={!columnsAddressStartValue}
        isSignature={true}
      />

      <CustomItem
        form={form}
        highlightColor={highlightColor}
        options={getOptionsColumnForSelect}
        fieldName={nameTableColumn.columnMeterReading}
        label="Столбец для показаний"
        requiredMessage="Пожалуйста, выберите столбец для показаний"
        onChange={onChangeColumnItem}
        isClear={true}
      />

      <CustomItem
        form={form}
        highlightColor={highlightColor}
        options={getOptionsColumnForSelect}
        fieldName={nameTableColumn.columnDate}
        label="Столбец даты последнего показания"
        onChange={onChangeColumnItem}
        isClear={true}
      />

      <div
        className={styles.btnCustom}
        onClick={onClickBtn}
      >
        Создать
      </div>
    </div>
  );
};

export default ItemContainer;
